module.exports = __webpack_public_path__ + "static/media/AddToCommunity.03e179db.svg";